import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import Project from "../../../../../model2/project/project"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"


export default class FieldProjectStartDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-start'
        this.label              = 'Start date'

        // this.renderComponents.tableCell     = FieldProto_TableCellReadOnly
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Project):boolean {
        return model.acl.canChangeStartDate
    }


    // Custom Methods

    tableCellOnValueChange = async (item: ItemModelV2, value:Moment|null, manager:TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const startDate = item.project.displayStartDate || item.project.startDate
                const endDate   = item.project.displayEndDate || item.project.endDate

                const endStartDiff  = moment(endDate).diff(moment(startDate), 'days')
                const newStartDate  = value ? moment(value) : null
                const newEndDate    = value ? moment(value).add(endStartDiff,'days') : null

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.project.updateStartDate(value, {keepCalendarDuration:true})
                item.project.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }



    }

}
